export default "__VITE_ASSET__B54e2ui$__"